<template>
  <div>
    <CreditsSummary v-if="filters.detailed==false" :credits="credits"></CreditsSummary>
    <div v-else v-for="credit in credits" :key="credit.id" class="m-60 p-40 border-left" >
      
      <div class="mt-30">
        <div  style="line-height:18px;float:left;">
          <span class="fs-12"><strong>Crédit #: </strong><PortausLink :id="credit.id" :label="credit.crNumber" path="/credit-notes/" :underline="true"></PortausLink></span>
          <span class="fs-12"><br><strong>Client : </strong> <PortausLink :id="credit.customer.id" :label="customerName(credit.customer.name,credit.customer.usualName)" path="/credit-notes/" :underline="true"></PortausLink></span>
          <span class="fs-12" v-if="credit.date"><br><strong>Date :</strong> {{_moment(credit.date)}}</span>
          <!-- <span class="fs-12" v-if="credit.paid_at"><br><strong>Payé le :</strong> {{_moment(invoice.paid_at)}}</span> -->
        </div>
        <div  style="line-height:18px;float:right;">
          <span class="fs-12"><el-tag style="margin-right:5px;" v-if="credit.status">{{$t('credit_notes.statuses.'+credit.status.code)}}</el-tag></span>
        </div>
      </div>
      <el-table :data="credit.lines" style="100%" ref="summary" :cell-style="{padding:'4px'}" stripe header-row-class-name="fs-12">
        <el-table-column  align="left" label="Description" prop="product.name" v-if="productCreditedType(credit)">
          <template slot-scope="scope">
            <span class="fs-12 secondary-text">
              <span>{{scope.row.product.name}}</span>
              <span v-if="scope.row.product.provider!=null">, {{customerName(scope.row.product.provider.name,scope.row.product.provider.usualName)}}
              </span>
              <span class="fs-11 secondary-text"><br>{{scope.row.product.sku}}</span>
            </span>
            <span class="fs-11 secondary-text"><br>{{scope.row.description}}</span>
          </template>
        </el-table-column>
        <el-table-column  align="left" label="Type de crédit" prop="product.name">
          <template slot-scope="scope">
            <span class="fs-12 secondary-text">
              <span v-if="scope.row.type">{{scope.row.type.name}}</span>
              <span v-else>S.O.</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column  align="center" label="Prix">
          <template slot-scope="scope">
            <span class="fs-12 secondary-text">{{$n(scope.row.price,'currency',credit.currency.code)}}</span>
          </template>
        </el-table-column>
        <el-table-column  align="center" prop="qty" label="Quantité">
          <template slot-scope="scope">
            <span class="fs-12 secondary-text">{{scope.row.qty}}</span>
          </template>
        </el-table-column>
        <el-table-column  align="right" prop="sub_total" label="Sous total">
          <template slot-scope="scope">
            <span class="fs-12 secondary-text">{{$n(scope.row.subTotal,'currency',credit.currency.code)}}</span>
          </template>
        </el-table-column>
      </el-table>
      <table style="width:100%;margin-top:20px;" v-if="credit">
          <tr>
            <td class="fs-12 secondary-text font-weight-800" style="text-align:right;">Sous-total : </td>
            <td class="fs-12 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(credit.subTotal,'currency',credit.currency.code)}}</td>
          </tr>
          <tr v-for="(tax, index) in credit.taxes" :key="index">
            <td class="fs-12 secondary-text" style="text-align:right;">{{tax.name || tax.label}} ({{tax.number || tax.taxNumber}}) : </td>
            <td class="fs-12 secondary-text" style="text-align:right;width:150px;">{{$n(tax.total,'currency',credit.currency.code)}}</td>
          </tr>
          <tr>
            <td class="fs-12 secondary-text font-weight-800" style="text-align:right;">Crédit émis : </td>
            <td class="fs-12 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(credit.total,'currency',credit.currency.code)}}</td>
          </tr>
          <tr v-if="credit.balance.paid > 0">
            <td class="fs-12 secondary-text" style="text-align:right;">Crédit utilisé : </td>
            <td class="fs-12 secondary-text" style="text-align:right;width:150px;">{{$n(credit.balance.paid,'currency',credit.currency.code)}}</td>
          </tr>
          <tr>
            <td class="fs-12 secondary-text font-weight-800" style="text-align:right;">Crédit restant : </td>
            <td class="fs-12 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(credit.balance.outstanding,'currency',credit.currency.code)}}</td>
          </tr>
      </table>
    </div>
  </div>
</template>
<script>

import moment from 'moment'
import { mapActions, mapState, mapGetters } from 'vuex';
import PortausLink from '@/components/portaus-link'
import CustomerUtil from '@/utils/customer-util'
import CreditsSummary from '@/components/creditNote/credits-summary.vue'
export default {
  name : "CreditsDetailCreditsView",
  props: {
    credits : {
      type : Array,
      default : () => []
  },
    filters : Object
	},
  data() {
    return {

    };
  },
  components : {
    PortausLink,
    CreditsSummary
  },
  methods : {
    productCreditedType(credit){
      return credit.type ==='PRODUCTS'
    },
    customerName(name, usual_name){
      return CustomerUtil.customerName(name, usual_name);
    },
    _moment(date, format='l'){
      return moment(date).format(format);
    }
  },
  computed : {

  }
}
</script>
<style lang="scss" scoped>


</style>
